<div class="row">
  <div *ngFor="let detail of singleRow" class="col col-lg-3 col-md-6 col-sm-12">
    <div class="detail">
      <p class="key" translate>DASHBOARD.DETAILED-DATA.{{ detail.key }}</p>
      <p class="value" *ngIf="!detail.compositeValue">
        <ng-container [ngTemplateOutlet]="singleDetailValue" [ngTemplateOutletContext]="{ detail: detail, sectionData: sectionData }"></ng-container>
      </p>
      <p class="value" *ngIf="detail.compositeValue">
        <span *ngFor="let singleValue of detail.value">
          <span class="key" translate>DASHBOARD.DETAILED-DATA.{{ singleValue.key }}</span>
          <span class="value">
            <ng-container [ngTemplateOutlet]="singleDetailValue" [ngTemplateOutletContext]="{ detail: singleValue, sectionData: sectionData }"></ng-container>
          </span>
        </span>
      </p>
    </div>
  </div>
</div>

<ng-template let-sectionData="sectionData" let-detail="detail" #singleDetailValue>
  {{
    detail.type === 'number'
      ? sectionData[detail.value] === null || sectionData[detail.value] === undefined
        ? '-'
        : sectionData[detail.value]
      : !sectionData[detail.value] || sectionData[detail.value] === '0001-01-01'
        ? '-'
        : sectionData[detail.value]
  }}
</ng-template>
